/**
 * ALP breadcrumb — trail built from in-session collection navigation (click path).
 * Persists in sessionStorage; no Home row; "/" suffix via CSS on link items.
 */
(function () {
  var STORAGE_KEY = 'alp_collection_nav_trail';
  var MAX_LEN = 12;

  function readTrail() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeTrail(trail) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trail));
    } catch (e) {}
  }

  function parseCollectionFromReferrer() {
    return getCollectionHandleFromUrl(document.referrer || '');
  }

  /** Collection handle from any URL string (referrer or location). */
  function getCollectionHandleFromUrl(url) {
    if (!url) return null;
    var mProduct = url.match(/\/collections\/([^/?#]+)\/products\//);
    if (mProduct) return mProduct[1];
    var m = url.match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function humanizeHandle(handle) {
    if (!handle) return '';
    return handle
      .split('-')
      .filter(Boolean)
      .map(function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      })
      .join(' ');
  }

  /** When URL has no collection (plain /products/…), match referrer handle to session trail or build a minimal crumb. */
  function inferCollectionFromReferrer(trail) {
    var h = getCollectionHandleFromUrl(document.referrer || '');
    if (!h) return null;
    if (trail && trail.length) {
      var found = trail.find(function (t) {
        return t.handle === h;
      });
      if (found) return found;
    }
    return {
      handle: h,
      url: window.location.origin + '/collections/' + h,
      title: humanizeHandle(h),
    };
  }

  /**
   * Record visiting a collection page — updates the click-path trail.
   * @param {{ title: string, url: string, handle: string }} current
   */
  function recordCollectionVisit(current) {
    if (!current || !current.handle) return;

    var trail = readTrail();

    // Refresh / same collection — keep existing trail
    if (trail.length && trail[trail.length - 1].handle === current.handle) {
      return;
    }

    var refHandle = parseCollectionFromReferrer();

    // No referrer (typed URL, some refreshes, new tab) → single-node trail
    if (!refHandle) {
      writeTrail([current]);
      return;
    }

    // User navigated back to an earlier collection in the trail
    var backIdx = trail.findIndex(function (t) {
      return t.handle === current.handle;
    });
    if (backIdx !== -1) {
      writeTrail(trail.slice(0, backIdx + 1));
      return;
    }

    // Normal forward: from ref collection to this one
    if (trail.length && trail[trail.length - 1].handle === refHandle) {
      trail.push(current);
      if (trail.length > MAX_LEN) trail = trail.slice(-MAX_LEN);
      writeTrail(trail);
      return;
    }

    // Referrer collection exists earlier in trail — branch / deep link
    var refIdx = trail.findIndex(function (t) {
      return t.handle === refHandle;
    });
    if (refIdx !== -1) {
      trail = trail.slice(0, refIdx + 1);
      trail.push(current);
      writeTrail(trail);
      return;
    }

    // Referrer not in trail (e.g. cross-link between collections) — new branch from referrer context
    writeTrail([current]);
  }

  function normalizeCollectionFromDataset(el) {
    var handle = el.getAttribute('data-bc-handle');
    var title = el.getAttribute('data-bc-title');
    var url = el.getAttribute('data-bc-url');
    if (!handle || !title || !url) return null;
    return { handle: handle, title: title, url: url };
  }

  /**
   * Drop or shorten stale trail on product page. Never clear session when referrer is missing
   * (plain /products/ links + rel=noreferrer from collection — trail was set on the collection page).
   *
   * - Collection in URL (Liquid currentCol): reset to [currentCol] unless navigation came from another collection page.
   * - No collection in URL: clear only when we know entry was not from a collection (same-origin non-collection, or external).
   */
  function syncProductPageTrail(liquidCol) {
    var ref = document.referrer || '';
    var refHasCollection = ref && /\/collections\//.test(ref);
    var isSameOrigin = ref && ref.indexOf(window.location.origin) === 0;
    var isExternal = ref && ref.indexOf(window.location.origin) !== 0;

    if (liquidCol) {
      if (!ref) return;
      if (isExternal) {
        writeTrail([liquidCol]);
        return;
      }
      if (isSameOrigin && !refHasCollection) {
        writeTrail([liquidCol]);
        return;
      }
      return;
    }

    // Plain /products/… — do not clear when referrer is missing (keeps trail from collection visit; noreferrer case).
    if (!ref) return;

    if (isExternal) {
      writeTrail([]);
      return;
    }
    if (isSameOrigin && !refHasCollection) {
      writeTrail([]);
      return;
    }
    // Referrer is a collection page — keep trail
  }

  /** Matches Liquid `main-icon` icon-breadcrumb-arrow-right (see .alp-breadcrumb__sep in alp.css). */
  function appendBreadcrumbSep(li) {
    var sep = document.createElement('span');
    sep.className = 'alp-breadcrumb__sep';
    sep.setAttribute('aria-hidden', 'true');
    var svgNs = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNs, 'svg');
    svg.setAttribute('xmlns', svgNs);
    svg.setAttribute('width', '6');
    svg.setAttribute('height', '9');
    svg.setAttribute('viewBox', '0 0 6 9');
    svg.setAttribute('fill', 'none');
    var path = document.createElementNS(svgNs, 'path');
    path.setAttribute('d', 'M0 0.380858L5.06363 4.5L0 8.61914L0.468186 9L6 4.5L0.468186 0L0 0.380858Z');
    path.setAttribute('fill', '#1A1A1A');
    svg.appendChild(path);
    sep.appendChild(svg);
    li.appendChild(sep);
  }

  function renderList(ul, items) {
    if (!ul || !items.length) return;
    ul.innerHTML = '';
    items.forEach(function (item, i) {
      var li = document.createElement('li');
      li.className = 'alp-breadcrumb__item';
      var isLast = i === items.length - 1;
      if (isLast) {
        li.classList.add('alp-breadcrumb__item--current');
        var span = document.createElement('span');
        span.textContent = item.title;
        li.appendChild(span);
      } else {
        var a = document.createElement('a');
        a.className = 'alp-breadcrumb__link';
        a.href = item.url;
        a.textContent = item.title;
        li.appendChild(a);
        appendBreadcrumbSep(li);
      }
      ul.appendChild(li);
    });
  }

  /** Collection links only; last segment is product title (current). */
  function renderProductList(ul, collectionItems, productTitle) {
    if (!ul) return;
    ul.innerHTML = '';
    (collectionItems || []).forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'alp-breadcrumb__item';
      var a = document.createElement('a');
      a.className = 'alp-breadcrumb__link';
      a.href = item.url;
      a.textContent = item.title;
      li.appendChild(a);
      ul.appendChild(li);
    });
    if (productTitle) {
      var liP = document.createElement('li');
      liP.className = 'alp-breadcrumb__item alp-breadcrumb__item--current';
      var span = document.createElement('span');
      span.textContent = productTitle;
      liP.appendChild(span);
      ul.appendChild(liP);
    }
  }

  function buildProductTrail(sessionTrail, liquidCol) {
    var items = sessionTrail && sessionTrail.length ? sessionTrail.slice() : [];
    var currentCol = liquidCol || inferCollectionFromReferrer(items);

    if (currentCol) {
      var idx = items.findIndex(function (t) {
        return t.handle === currentCol.handle;
      });
      if (idx >= 0) {
        items = items.slice(0, idx + 1);
      } else {
        items.push(currentCol);
      }
    }

    if (!items.length) return [];

    return items;
  }

  function init() {
    var root = document.querySelector('[data-alp-breadcrumb]');
    if (!root) return;

    var pageType = root.getAttribute('data-page-type') || '';
    var ul = root.querySelector('.alp-breadcrumb__list');
    if (!ul) return;

    var currentCol = normalizeCollectionFromDataset(root);

    if (pageType === 'collection') {
      root.style.display = '';
      return;
    }

    if (pageType === 'product') {
      var productTitle = root.getAttribute('data-product-title') || '';
      var isLiquidBreadcrumb =
        root.getAttribute('data-breadcrumb-renderer') === 'liquid' ||
        root.getAttribute('data-bc-static') === '1' ||
        root.getAttribute('data-bc-trail-preset') === '1';
      if (isLiquidBreadcrumb) {
        syncProductPageTrail(currentCol);
        root.style.display = '';
        return;
      }
      syncProductPageTrail(currentCol);
      var trail = readTrail();
      var items = buildProductTrail(trail, currentCol);
      if (!items.length && !productTitle) {
        root.style.display = 'none';
        return;
      }
      if (
        !items.length &&
        productTitle &&
        (ul.querySelectorAll('.alp-breadcrumb__link').length > 0 ||
          ul.querySelectorAll('li').length > 1)
      ) {
        root.style.display = '';
        return;
      }
      renderProductList(ul, items, productTitle);
      root.style.display = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
